<template>
  <div id="app">
      <router-view v-if="isRouterAlive">

      </router-view>
  </div>
</template>

<script>
export default {
    name: 'tudinn',
    provide(){
      return{
        reload:this.reload
      }
    },
    data() {
      return{
        isRouterAlive:true,
      }
    },
    mounted() {
      
    },
    methods:{
      reload(){
        this.isRouterAlive=false
        this.$nextTick(function(){
          this.isRouterAlive=true
        })
      },
      
    },
}
</script>

<style>
body{
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* overflow-x: hidden; */

}
.el-header{
  height: 120px!important;
  padding: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue